import { z } from 'zod';

import { timeRangeSchema } from '@/lib/time-range';

export const reportLengthInputSchema = z.enum(['normal', 'extended']);

export type ReportLengthInput = z.infer<typeof reportLengthInputSchema>;

export const dailyDigestInputSchema = z.object({
  enabled: z.boolean().optional(),
  reportLength: reportLengthInputSchema.optional(),
  scheduleHour: z.number().int().min(0).max(23).optional(),
  timezone: z.string().min(1).optional(),
  timeRange: timeRangeSchema.optional(),
});

export type DailyDigestInput = z.infer<typeof dailyDigestInputSchema>;

export const pulsePreferenceInputSchema = z.object({
  enabled: z.boolean().optional(),
  emailEnabled: z.boolean().optional(),
  scheduleHour: z.number().int().min(0).max(23).optional(),
  maxItems: z.number().int().positive().optional(),
  maxFetchPerDay: z.number().int().min(1).max(4).optional(),
});

export type PulsePreferenceInput = z.infer<typeof pulsePreferenceInputSchema>;
